<template>
    <div class="index">
        <box-helper
            headline="Overblik"
            identifier="index"
        />
        <div class="container section">
            <title-block headline="<b>Overblik</b>" class="mb-xl" position="center">
                <p slot="text">
                    Hvad skal der fokus på i dag?
                </p>
            </title-block>
            <div class="content">
                <div class="economy-overview" v-if="$auth.user().roles[0].name !== 'department-responsible'">
                    <div class="row nomargin">
                        <div class="col-lg-4">
                            <div class="text">
                                EBITDA året til dato
                                <d-tooltip placement="inline" identifier="index.ebitda" />
                            </div>
                            <div class="number color__main" v-if="!$auth.user().name.includes('Demo')">
                                <span v-if="calculations && keyfigures.ebitda">
                                    {{ keyfigures.ebitda | currency }}
                                </span>
                                <span v-else>-</span>
                            </div>
                            <div class="number color__main" v-else>
                                {{ 324353 | currency }}
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="text">
                                Forventet omsætning i denne måned
                                <d-tooltip placement="inline" identifier="index.expectedRevenue" />
                            </div>
                            <div class="number color__good" v-if="!$auth.user().name.includes('Demo')">
                                <span v-if="calculations && keyfigures.expected_revenue !== undefined">
                                    <span v-if="keyfigures.expected_revenue !== 0">
                                        {{ keyfigures.expected_revenue | currency }}
                                    </span>
                                    <router-link tag="span" :to="{name: 'Settings', params: {'selected': 'budget'}}" class="small" style="color:#fff;margin:0;padding:0;cursor:pointer;" v-else>
                                        Læg budget nu <i class="fas fa-arrow-right" />
                                    </router-link>
                                </span>
                                <span v-else>-</span>
                            </div>
                            <div class="number color__good" v-else>
                                {{ 538000 | currency }}
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="text">
                                Forventede udgifter i denne måned
                                <d-tooltip placement="inline" identifier="index.expectedCosts" />
                            </div>
                            <div class="number color__bad" v-if="!$auth.user().name.includes('Demo')">
                                <span v-if="calculations && keyfigures.expected_costs !== undefined">
                                    <span v-if="keyfigures.expected_costs !== 0">
                                        {{ keyfigures.expected_costs | currency }}
                                    </span>
                                    <router-link tag="span" :to="{name: 'Settings', params: {'selected': 'budget'}}" class="small" style="color:#fff;margin:0;padding:0;cursor:pointer;" v-else>
                                        Læg budget nu <i class="fas fa-arrow-right" />
                                    </router-link>
                                </span>
                                <span v-else>-</span>
                            </div>
                            <div class="number color__bad" v-else>
                                {{ 493000 | currency }}
                            </div>
                        </div>
                    </div>
                </div>
                
                <value-chain />

                <div class="number-overview">
                    <div class="row">
                        <div class="col-lg-2">
                            <number-card
                                heading="Tilbud"
                                description="der afventer afgørelse"
                                :number="calculations.offer"
                                icon="file-alt"
                                state="avg"
                                linkParent="ProjectsOperations"
                                linkChild="offerProjects"
                                tooltipIdentifier="index.offerProjects"
                            />
                        </div>
                        <div class="col-lg-2">
                            <number-card
                                heading="Opgaver"
                                description="der endnu ikke er påbegyndt"
                                :number="calculations.open"
                                icon="inbox-in"
                                state="avg"
                                linkParent="ProjectsOperations"
                                linkChild="openProjects"
                                tooltipIdentifier="index.openProjects"
                            />
                        </div>
                        <div class="col-lg-2">
                            <number-card
                                heading="Igangværende opgaver"
                                description="der arbejdes på lige nu"
                                :number="calculations.ongoing"
                                icon="clock"
                                state="bad"
                                linkParent="ProjectsOperations"
                                linkChild="ongoingProjects"
                                tooltipIdentifier="index.ongoingProjects"
                            />
                            <br>
                            <number-card
                                heading="Igangværende opgaver"
                                :description="'uden registreringer i ' + $store.state.config.companyMeta.settings.snoozed_days + ' dage '"
                                :number="calculations.snoozed"
                                icon="snooze"
                                state="bad"
                                linkParent="ProjectsOperations"
                                linkChild="snoozedProjects"
                                tooltipIdentifier="index.snoozedProjects"
                            />
                            <br>
                            <number-card
                                heading="Reklamationer"
                                description="der ikke er afsluttet"
                                :number="calculations.claims"
                                icon="comment-exclamation"
                                state="good"
                                linkParent="ProjectsOperations"
                                linkChild="openClaims"
                                tooltipIdentifier="index.openClaims"
                            />
                        </div>
                        <div class="col-lg-2">
                            <number-card
                                heading="Afsluttede opgaver"
                                description="der ikke er fakturerede"
                                :number="calculations.unbilled"
                                icon="envelope-open-dollar"
                                state="avg"
                                linkParent="ProjectsOperations"
                                linkChild="noInvoiceProjects"
                                tooltipIdentifier="index.unbilledProjects"
                            />
                        </div>
                        <div class="col-lg-2">
                            <number-card
                                heading="Fakturaer"
                                description="der endnu ikke er betalt"
                                :number="calculations.payment_pending"
                                icon="envelope-open-dollar"
                                state="avg"
                                linkParent="EconomyOperations"
                                linkChild="unpaidInvoices"
                                tooltipIdentifier="index.unpaidInvoices"
                            />
                        </div>
                        <div class="col-lg-2">
                            <number-card
                                heading="Fakturaer"
                                :description="'hvor betaling er overskredet med ' + $store.state.config.companyMeta.settings.overdue_days + ' dage'"
                                :number="calculations.payment_exceeded"
                                icon="calendar-exclamation"
                                state="bad"
                                :totalValue="calculations.payment_exceeded_total"
                                linkParent="EconomyOperations"
                                linkChild="exceededPayments"
                                tooltipIdentifier="index.overdueInvoices"
                            />
                        </div>
                    </div>
                </div>

                <!--<div class="number-overview">
                    <div class="row nomargin">
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Opgaver"
                                description="der endnu ikke er påbegyndt"
                                :number="calculations.open"
                                icon="inbox-in"
                                state="avg"
                                linkParent="ProjectsOperations"
                                linkChild="openProjects"
                                tooltipIdentifier="index.openProjects"
                            />
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Igangværende opgaver"
                                description="der arbejdes på lige nu"
                                :number="calculations.ongoing"
                                icon="clock"
                                state="bad"
                                linkParent="ProjectsOperations"
                                linkChild="ongoingProjects"
                                tooltipIdentifier="index.ongoingProjects"
                            />
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Igangværende opgaver"
                                :description="'uden registreringer i ' + $store.state.config.companyMeta.settings.snoozed_days + ' dage '"
                                :number="calculations.snoozed"
                                icon="snooze"
                                state="bad"
                                linkParent="ProjectsOperations"
                                linkChild="snoozedProjects"
                                tooltipIdentifier="index.snoozedProjects"
                            />
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Reklamationer"
                                description="der ikke er afsluttet"
                                :number="calculations.claims"
                                icon="comment-exclamation"
                                state="good"
                                linkParent="ProjectsOperations"
                                linkChild="openClaims"
                                tooltipIdentifier="index.openClaims"
                            />
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Afsluttede opgaver"
                                description="der ikke er fakturerede"
                                :number="calculations.unbilled"
                                icon="envelope-open-dollar"
                                state="avg"
                                linkParent="ProjectsOperations"
                                linkChild="noInvoiceProjects"
                                tooltipIdentifier="index.unbilledProjects"
                            />
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <number-card
                                heading="Fakturaer"
                                :description="'hvor betaling er overskredet med ' + $store.state.config.companyMeta.settings.overdue_days + ' dage'"
                                :number="calculations.payment_exceeded"
                                icon="calendar-exclamation"
                                state="bad"
                                :totalValue="calculations.payment_exceeded_total"
                                linkParent="EconomyOperations"
                                linkChild="exceededPayments"
                                tooltipIdentifier="index.overdueInvoices"
                            />
                        </div>
                    </div>
                </div>-->

            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import "../../styles/vars.scss";
    
    .index {

        .economy-overview {
            background: $color--dark;
            margin-bottom: $margin--xl;
            margin-bottom: $margin--large;
            padding: $padding--main;
            border-radius: $borderradius--main;
            text-align: center;
            box-shadow: $boxshadow--creative;
            color: #fff;

            [class^="col-"] {

                &:nth-of-type(2) {
                    border-left: 1px solid lighten($color--dark, 10%);
                    border-right: 1px solid lighten($color--dark, 10%);
                }

                .text {
                    font-size: $fontsize--main;
                    font-weight: $fontweight--main;
                    margin-bottom: $margin--small / 2;
                }

                .number {
                    font-size: $fontsize--xxl;
                    font-weight: $fontweight--bold;
                    font-family: $fontfamily--main;
                }
            }
        }

        .number-overview {
            margin-bottom: $margin--xl;
            margin-bottom: $margin--main;
        }

        .tables-overview {
            margin-bottom: $margin--xl;
            margin-bottom: $margin--main;
        }
    }

</style>

<script>
import * as calculationService from '@/services/calculationService'

export default {
    data () {
        return {
            showHelper: false,
            keyfigures: null,
            calculations: {
                offer: null,
                claims: null,
                close_to_budget: null,
                ongoing: null,
                open: null,
                payment_pending: null,
                payment_exceeded: null,
                payment_exceeded_total: null,
                snoozed: null,
                unbilled: null
            }
        }
    },
    methods: {
        getCalculations () {
            this.calculations = {
                claims: null,
                close_to_budget: null,
                ongoing: null,
                open: null,
                payment_exceeded: null,
                payment_exceeded_total: null,
                snoozed: null,
                unbilled: null
            }
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            calculationService.find('index/counts', params, (response) => {
                this.calculations = response.data
            }, (err) => {
                console.log(err)
            })
            calculationService.find('index-economy', params, (response) => {
                this.keyfigures = response.data
            }, (err) => {
                console.log(err)
            })
        }
    },
    created () {
        this.getCalculations()
    },
    computed: {
        globalParams () {
            // let startDate = this.$store.getters.getStartDate
            // let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return department
        }
    },
    watch: {
        globalParams: function () {
            this.getCalculations()
        }
    },
    components: {
        'value-chain': require('./components/valueChain.vue')
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?4470b1d5